import React from 'react';

import marked from 'marked';

import ShopViewPriceBlock from './shop-view-price-block';

import AdditionalPhotos from '../controls/additional-photos';
import ShirtColorsControl from '../controls/shirt-colors-control';

import ShirtProduct from '../products/shirt-product';
import ShirtSizesControl from '../controls/shirt-sizes-control';
import ProductImageContainer from '../controls/product-image-container';

class ShirtShopView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      size: 'S',
      color: props.data.Colors[0],
      quantity: 1,
      showCurrencyRequired: false,
    };

    this.calculatedPrice = this.calculatedPrice.bind(this);
    this.changeSize = this.changeSize.bind(this);
    this.changeColor = this.changeColor.bind(this);
    this.compiledId = this.compiledId.bind(this);
    this.description = this.description.bind(this);
  }

  calculatedPrice() {
    const calculatedPrices = ShirtProduct.calculatedPrice(this.props.data.Price_Profile[0].data.Conversions);

    if (typeof window !== 'undefined' && window.Snipcart) {
      const cart = window.Snipcart.store.getState().cart;

      return calculatedPrices[cart.currency];
    } else {
      return calculatedPrices['usd'];
    }
  }

  changeColor(color) {
    this.setState({color: color});
  }

  changeSize(size) {
    this.setState({size: size});
  }

  compiledId() {
    return ShirtProduct.compiledId(this.props.data.Reference, this.state.size, this.state.color);
  }

  description() {
    return ShirtProduct.description(this.state.size, this.state.color);
  }

  render() {
    return (
      <>
      <div className="product-view__main-view">
        <div>
          <ProductImageContainer
            data={this.props.data}
            showLightbox={this.props.showLightbox}
          />
          {(this.props.data.Gallery_Image_Paths) ? (
            <AdditionalPhotos
              paths={this.props.data.Gallery_Image_Paths}
              showLightbox={this.props.showLightbox}
            />
          ) : null}
        </div>
        <div>
          <div className="product-view__controls-container">
            <div className="product-view__title-block">
              <span className="product-view__product-title">{this.props.data.Name}</span>
            </div>

            <div className="product-view__meta-block">
              <ShirtSizesControl
                onChange={this.changeSize}
                size={this.state.size}
                showModalWithContent={this.props.showModalWithContent}
              />
            </div>

            <div className="product-view__meta-block">
              <ShirtColorsControl
                onChange={this.changeColor}
                color={this.state.color}
                colors={this.props.data.Colors}
              />
            </div>

            <div className="product-view__meta-block">
              <span className="product-view__meta-label">Overview</span>
              <div
                className="product-view__meta-value"
                dangerouslySetInnerHTML={
                  { __html: marked(this.props.data.Short_Description).replace('<p>', '').replace('</p>', '')}
                }
              />
            </div>

            {(this.props.loading) ? (
              <div className="product-view__meta-block">
                <div className="product-view__meta-value">
                  Loading Prices…
                </div>
              </div>
            ) : (
              <>
                <ShopViewPriceBlock
                  data={ this.props.data }
                  formattedPrice={ this.props.formattedPrice }
                  calculatedPrice={ this.calculatedPrice }
                  onMultiCurrencyChange={ this.props.onMultiCurrencyChange }
                  cartCurrency={ this.props.cartCurrency }
                />

                {(this.props.data.Unavailable) ? (
                  <div className="product-view__meta-block">
                    <div className="product-view__meta-value">
                      We’re sorry. This product is temporarily unavailable.
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="product-view__meta-block">
                      <span className="product-view__meta-label">Quantity</span>
                      <span className="product-view__meta-value">
                        <input
                          type="number"
                          name="quantity"
                          value={ this.state.quantity }
                          onChange={ (e) => this.setState({ quantity: e.target.value }) }
                        />
                      </span>
                    </div>

                    {(this.props.cartCurrency) ? (
                      <div>
                        <button
                          className="product-view__buy-button snipcart-add-item"
                          data-item-id={this.compiledId()}
                          data-item-name={this.props.data.Name}
                          data-item-price={
                            (this.props.data.Discount_Price_Profile) ? (
                              this.props.serializedPrices(this.calculatedPrice(this.props.data.Discount_Price_Profile[0]))
                            ) : (
                              this.props.serializedPrices(this.calculatedPrice(this.props.data.Price_Profile[0]))
                            )}
                          data-item-url={`${process.env.GATSBY_SERVER_ROOT}/data/products/${this.props.data.Reference}.json`}
                          data-item-image={`https://the-public-domain-review.imgix.net${this.props.data.Image_File_Path}?w=240&h=240&fit=max`}
                          data-item-description={this.description()}
                          data-item-categories="shirts"
                          data-item-quantity={this.state.quantity}
                          >
                          Add to Cart
                        </button>
                      </div>
                    ) : (
                      <>
                        <button
                          className="product-view__disabled-buy-button"
                          onClick={(e) => this.setState({ showCurrencyRequired: true })}
                        >
                          Add to Cart
                        </button>
                        {(this.state.showCurrencyRequired) ? (
                          <span className="product-view__currency-required">
                            Select a currency above to add to cart.
                          </span>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      </>
    );
  }
}

export default ShirtShopView;
